module.exports = __webpack_public_path__ + "img/更新到器件库.361af495.svg";